import React from 'react';

import { Typography } from '@material-ui/core';
import { StyledAvatar } from 'components/avatars';
import { CheckRadio } from 'screens/home/tasksList/styles';
import styled from 'styled-components';
import { StyledBox } from 'styles/common';

import { UncheckedCircle } from 'constants/icons';
import theme from 'constants/theme';

const ChildWrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 350px;
  max-width: 450px;
  flex-direction: row;
  align-items: center;
  padding: 1rem 1rem;
`;

const Divider = styled.div`
  border-bottom: 1px solid ${theme.palette.borders.lighterGrey};
  margin: 0 1.5rem;
`;

const DropdownListElements = ({
  label,
  avatar,
  designation,
  checked,
  radioColor = 'green',
  hoverColor = 'textSecondary',
}) => (
  <StyledBox width={1}>
    <ChildWrapper>
      {avatar && <StyledAvatar src={avatar} size="smallest" />}
      <Typography style={{ marginLeft: '1rem' }} variant="body1">
        {label}
      </Typography>
      {designation && (
        <Typography variant="body1" color="textSecondary">
          {', '}
          {designation}
        </Typography>
      )}
      <CheckRadio
        disableRipple
        checked={checked}
        style={{ marginLeft: 'auto' }}
        checkedIcon={<UncheckedCircle size="smallest" color={radioColor} />}
        icon={<UncheckedCircle size="smallest" color="textSecondary" />}
        hoverColor={hoverColor}
      />
    </ChildWrapper>
    <Divider />
  </StyledBox>
);

export default DropdownListElements;
